import { supabase } from './supabase';

const snapshots = new Map();
const pending = new Map();
const REGISTRATION_WINDOW_MS = 5 * 60 * 1000;

export function browserSignupAttribution() {
  const acquisition = window.instantTranscriberAcquisition;
  return {
    ...(acquisition?.affiliateFirstTouch?.() || { affiliate_state: 'none' }),
    acquisition: acquisition?.context?.() || {},
  };
}

export function getSignupAttribution(user) {
  return user?.id ? snapshots.get(`${user.id}:${user.is_anonymous === true}`) : undefined;
}

export function loadSignupAttribution(user) {
  if (!user?.id) return Promise.resolve(null);
  const key = `${user.id}:${user.is_anonymous === true}`;
  const cached = snapshots.get(key);
  const firstTouch = browserSignupAttribution();
  const resolvingOriginalCode = cached?.affiliate_state === 'affiliate' && !cached.promotekit_referral
    && firstTouch.promotekit_referral && cached.promotekit_code_value
    && firstTouch.promotekit_code_param === cached.promotekit_code_param
    && firstTouch.promotekit_code_value === cached.promotekit_code_value;
  if (cached && !resolvingOriginalCode) return Promise.resolve(cached);
  if (pending.has(key)) return pending.get(key);
  const request = (async () => {
    const { data, error } = await supabase.rpc('capture_signup_attribution', { first_touch: firstTouch });
    if (error) throw error;
    if (!data || data.user_id !== user.id) throw new Error('Signup attribution could not be verified.');
    snapshots.set(key, data);
    return data;
  })().finally(() => pending.delete(key));
  pending.set(key, request);
  return request;
}

export function clearSignupAttributionCache() {
  snapshots.clear();
}

export function originalAcquisition(user) {
  return getSignupAttribution(user)?.acquisition || {};
}

export function isRecentRegistration(user) {
  if (!isVerifiedRegistration(user)) return false;
  const registeredAt = Date.parse(getSignupAttribution(user)?.registered_at);
  const age = Date.now() - registeredAt;
  return Number.isFinite(registeredAt) && age >= 0 && age <= REGISTRATION_WINDOW_MS;
}

export function isVerifiedRegistration(user) {
  return Boolean(user?.id && !user.is_anonymous && user.email && (user.email_confirmed_at
    || user.identities?.some(identity => ['google', 'apple'].includes(identity.provider))));
}

export function registrationMethod(user, attempt = {}) {
  return attempt.method || user?.identities?.find(identity => identity.provider !== 'anonymous')?.provider
    || user?.app_metadata?.provider || 'unknown';
}
